/**
 * Returns the visible plain-text character count of a rich-text HTML string.
 * HTML tags are stripped and non-breaking spaces are normalised to regular spaces
 * so that validation matches what the user actually sees in the editor.
 */
export function getRichTextLength(value: unknown): number {
    if (typeof value !== 'string' || !value.length) {
        return 0;
    }

    if (typeof DOMParser === 'undefined') {
        return value.replaceAll(/<[^>]+>/g, '').replaceAll(/(&nbsp;|\u00A0)/g, ' ').length;
    }

    const parsedDocument = new DOMParser().parseFromString(value, 'text/html');
    return (parsedDocument.body.textContent ?? '').replaceAll('\u00A0', ' ').length;
}
